import { FC } from 'react';
import cn from 'classnames';

import { ISupplementResponseDetailsFieldProps } from './SupplementResponseDetailsField.interface';

import './style.scss';

const SupplementResponseDetailsField: FC<ISupplementResponseDetailsFieldProps> = ({
  className,
  label,
  children,
}) => (
  <div className={cn('supplement-response-details-field', className)}>
    <div className="supplement-response-details-field__label">{label}</div>

    <div className="supplement-response-details-field__value">{children}</div>
  </div>
);

export default SupplementResponseDetailsField;
